import { Card, CardContent } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
const CustomCard = ({ scanDetails, isLoading, kernelDiamensions }) => {

  const formattedKernelDiamensions = [
    ...(kernelDiamensions || []),
    scanDetails?.weight_with_foreign_value
      ? `Weight With Foreign Value:${scanDetails.weight_with_foreign_value}`
      : null
  ].filter(Boolean);

  return (
    <>
      {isLoading ? (
        <CardContent sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress />
        </CardContent>
      ) : (
        <>
          <Card
            sx={{
              backgroundColor: '#E8F5E9',
              borderRadius: '4px',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
              width: '100%',
              display: 'flex'
            }}
          >
            <>
              <CardContent sx={{ flex: 1 }}>
                <div className="card-container">
                  <div className="key-value-pair">
                    <span className="key">User Name:</span>
                    <span className="value">{`${scanDetails?.first_name} ${scanDetails?.last_name}`}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Phone/Email:</span>
                    <span className="value">
                      {scanDetails?.email !== null && scanDetails?.phone_number !== null ? (
                        <span>
                          {scanDetails?.email} / {scanDetails?.phone_number}
                        </span>
                      ) : (
                        <span>
                          {scanDetails?.email || scanDetails?.phone_number}
                        </span>
                      )}
                    </span>
                  </div>

                  <div className="key-value-pair">
                    <span className="key">Grain Type:</span>
                    <span className="value">{scanDetails?.crop_name}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Grain Variety:</span>
                    <span className="value">
                      {scanDetails?.variety_name}
                      {scanDetails?.cv_variety_name && ` (${scanDetails.cv_variety_name})`}
                    </span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Machine:</span>
                    <span className="value">{scanDetails?.machine_name} ({scanDetails?.machine_code})</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Reported Moisture:</span>
                    <span className="value">
                      {scanDetails?.moisture_value != null
                        ? `${scanDetails.moisture_value}%`
                        : "-"}
                    </span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Reported Weight:</span>
                    <span className="value">
                      {scanDetails?.weight_value != null
                        ? `${scanDetails.weight_value} gm`
                        : "-"}
                    </span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Location:</span>
                    <span className="value">{scanDetails?.location_name}</span>
                  </div>
                </div>
              </CardContent>
              <CardContent sx={{ flex: 1 }}>
                <div className="card-container">
                  {scanDetails && (
                    <>
                      <div className="key-value-pair">
                        <span className="key">Result ID:</span>
                        <span className="value">{scanDetails?.scan_id}</span>
                      </div>
                      <div className="key-value-pair">
                        <span className="key">Sub Scan ID:</span>
                        <span className="value">{scanDetails?.sub_scan_id}</span>
                      </div>
                    </>
                  )}
                  <div className="key-value-pair">
                    <span className="key">Login ID:</span>
                    <span className="value">{scanDetails?.user_name}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Scan Date:</span>
                    <span className="value">{scanDetails?.created_at}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Organisation:</span>
                    <span className="value">{scanDetails?.company_name}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Machine Instance Id:</span>
                    <span className="value">{scanDetails?.machine_instance_id}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Application Version:</span>
                    <span className="value">{scanDetails?.build_version}</span>
                  </div>
                  <div className="key-value-pair">
                    <span className="key">Phone device Name:</span>
                    <span className="value">{scanDetails?.device_info}</span>
                  </div>
                </div>
              </CardContent>
            </>
          </Card>
          {formattedKernelDiamensions && formattedKernelDiamensions.length > 0 && (
            <Card
              sx={{
                backgroundColor: '#E8F5E9',
                borderRadius: '4px',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <CardContent sx={{ flex: 1 }}>
                <div className="card-container">
                  {formattedKernelDiamensions.slice(0, Math.ceil(formattedKernelDiamensions.length / 2)).map((item, index) => (
                    <div className="key-value-pair" key={index}>
                      <span className="key">{item.split(':')[0]}</span>
                      <span className="value">{item.split(':')[1]}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
              <CardContent sx={{ flex: 1 }}>
                <div className="card-container">
                  {formattedKernelDiamensions.slice(Math.ceil(formattedKernelDiamensions.length / 2)).map((item, index) => (
                    <div className="key-value-pair" key={index}>
                      <span className="key">{item.split(':')[0]}</span>
                      <span className="value">{item.split(':')[1]}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
}

export default CustomCard;
